'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgCart = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    var computedProps = tslib_es6.__assign({ width: 20, height: 20, fill: 'currentColor' }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 20 20" }, computedProps, { "data-testid": "cart-icon-normal" }),
        React__default['default'].createElement("path", { fillRule: "evenodd", d: "M10.0123 1C11.7864 1 13.2518 2.32351 13.4776 4.03832L19.9905 4.03909L20 19L0.0122864 18.9999L0 4.03902L6.54699 4.03832C6.77276 2.32351 8.23817 1 10.0123 1ZM18.9896 5.03582L0.999317 5.03575V17.9999L18.9896 17.9999V5.03582ZM7.43122 4.03853C7.6491 2.80886 8.72185 1.87506 10.0124 1.87506C11.303 1.87506 12.3757 2.80886 12.5936 4.03853H7.43122Z" })));
};
var CartActive = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    var computedProps = tslib_es6.__assign({ width: 20, height: 20, fill: 'currentColor' }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 20 20" }, computedProps, { "data-testid": "cart-icon-active" }),
        React__default['default'].createElement("path", { d: "M13.4776 4.03832C13.2518 2.32351 11.7864 1 10.0123 1C8.23817 1 6.77276 2.32351 6.54699 4.03832L0 4.03902L0.0122864 18.9999L20 19L19.9905 4.03909L13.4776 4.03832ZM7.43115 4.03853C7.64903 2.80886 8.72178 1.87506 10.0123 1.87506C11.3029 1.87506 12.3756 2.80886 12.5935 4.03853H7.43115Z", fill: "currentColor" })));
};
var Cart = function (_a) {
    var props = tslib_es6.__rest(_a, []);
    return React__default['default'].createElement(SvgCart, tslib_es6.__assign({}, props));
};
CartActive['displayName'] = 'Cart.Active';
Cart.Active = CartActive;

exports.default = Cart;
//# sourceMappingURL=index.js.map
